import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import Dropzone from 'react-dropzone'

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import indigo from '@material-ui/core/colors/indigo';
import red from '@material-ui/core/colors/red';

import {
  startAddWebsitePortfolio,
  startEditWebsitePortfolio,
  startRemoveWebsitePortfolio,
} from 'store/actions/website';
import {
  startAddFile,
} from '../../../../store/actions/files';
import { ConfirmDialog } from 'components/admin/Dialogs';

const styles = theme => ({
  avatar: {
    marginRight: theme.spacing.unit*2,
  },
  card: {
    marginTop: theme.spacing.unit*3,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
  },
  name: {
    marginRight: theme.spacing.unit*2,
  },
  rootContent: {
    backgroundColor: indigo[50],
    width: "450px",
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    flexGrow: 1,
    marginRight: theme.spacing.unit,
  },
  description: {
    marginBottom: theme.spacing.unit*3,
  },
  dialogActions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  media: {
    height: 0,
    marginTop: theme.spacing.unit,
    paddingTop: '56.25%', // 16:9
    '&:hover': {
      cursor: 'pointer',
    },
  },
  iconError: {
    display: "flex",
    justifyContent: "center",
    color: red[500],
  },
});

const validate = (portfolioItem) => {
  const errors = {};
  const requiredFields = [ 'title', 'category', 'fileData' ];
  requiredFields.forEach(field => {
    if (!portfolioItem[field]) {
      errors[field] = 'Required';
    }
  });

  const validation = { errors, isInvalid: !!Object.keys(errors).length };
  validation.validateField = function (field) {
      return this.errors[field];
  };

  return validation;
}


class PortfolioDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showValidation: false,
      showDelete: false,
    }
  }

  acceptedTypes() {
    return "image/jpeg, image/png, image/gif, image/svg+xml";
  }
  onDrop(acceptedFiles, rejectedFiles) {
    // console.log("accepted", acceptedFiles);
    // console.log("rejected:", rejectedFiles);
    // if (acceptedFiles.length > 0) {
    //   if (this.state.file.title === "") {
    //     this.handleChange("title", acceptedFiles[0].name);
    //   }
    //   this.handleChange("type", acceptedFiles[0].type);
    //   this.handleChange("fileData", acceptedFiles[0]);
    // }
  }

  handleCancel = () => {
    this.setState({ showDelete: false });
  }

  handleDelete = () => {
    const { portfolioItem, handleClose, startRemoveWebsitePortfolio } = this.props;

    startRemoveWebsitePortfolio(portfolioItem.id)
      .then(() => handleClose());
  }

  render() {
    const {
      classes,
      portfolioItem,
      file,
      handleClose,
      handleChange,
      startAddWebsitePortfolio,
      startEditWebsitePortfolio,
      startAddFile,
    } = this.props;
    const { showDelete, showValidation, validation } = this.state;
    const type = portfolioItem.id === undefined ? "add" : "edit";
    let imgURL;
    if (portfolioItem.fileData) {
      imgURL = portfolioItem.fileData.preview;
    } else {
      imgURL = portfolioItem.downloadURL;
    }

    return(
      <div>
        <ConfirmDialog
          open={showDelete}
          title="Delete Portfolio Item"
          contentText="This action will delete the portfolio item. Proceed?"
          handleCancel={this.handleCancel}
          handleOk={this.handleDelete}
        />
        <Dialog
          maxWidth="md"
          open={portfolioItem === undefined ? false : true}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle>
            <div className={classes.header}>
              <Avatar aria-label="Portfolio" className={classes.avatar}>
                S
              </Avatar>
              <div>
                <Typography variant="subheading">
                  {type === "edit" ? "Edit Portfolio" : "Add Portfolio"}
                </Typography>
              </div>
            </div>
          </DialogTitle>
          <DialogContent classes={{root: classes.rootContent}}>
            <Card className={classes.card}>
              <CardContent className={classes.content}>
                <div className={classes.row}>
                  <TextField
                    error={(showValidation && !!validation.validateField("title"))}
                    helperText={(showValidation && validation.validateField("title"))}
                    className={classes.title}
                    label="Title"
                    placeholder="Enter title"
                    margin="normal"
                    value={portfolioItem.title}
                    onChange={ event => {
                      if (showValidation) {
                        const validation = validate({ ...portfolioItem, title: event.target.value });
                        this.setState({
                          showValidation: true,
                          validation
                        });
                      }
                      handleChange("title", event.target.value);
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={portfolioItem.show}
                        onChange={ () => handleChange("show", !portfolioItem.show)}
                      />
                    }
                    label="Show"
                  />
                </div>
                <TextField
                  error={(showValidation && !!validation.validateField("category"))}
                  helperText={(showValidation && validation.validateField("category"))}
                  className={classes.description}
                  label="Category"
                  placeholder="Enter category"
                  margin="normal"
                  value={portfolioItem.category}
                  onChange={ event => {
                    if (showValidation) {
                      const validation = validate({ ...portfolioItem, category: event.target.value });
                      this.setState({
                        showValidation: true,
                        validation
                      });
                    }
                    handleChange("category", event.target.value);
                  }}
                />
                <Dropzone
                  style={{
                    width : "95%", height : "100%",
                    border : "2px dashed grey",
                    borderRadius: "5%",
                    padding: '10px',
                  }}
                  accept={this.acceptedTypes()}
                  onDrop={(acceptedFiles, rejectedFiles) => {
                    if (showValidation) {
                      const validation = validate({ ...portfolioItem, fileData: 'ok' });
                      this.setState({
                        showValidation: true,
                        validation
                      });
                    }
                    handleChange("fileData", acceptedFiles[0]);
                  }}
                >
                    <div >
                      <Typography variant="caption">
                        Drop photo here, or click to select photo to upload.
                      </Typography>
                      <CardMedia
                        className={classes.media}
                        image={imgURL}
                      />
                    </div>
                </Dropzone>
                { showValidation && !!validation.validateField("fileData") &&
                  <Typography className={classes.iconError}>Photo Required</Typography>
                }
              </CardContent>
            </Card>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={() => this.setState({ showDelete: true })}>
              Delete
            </Button>
            <div>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button
                onClick={() => {
                  const validation = validate(portfolioItem);
                  console.log("portfolio validation:", validation);
                  if (validation.isInvalid) {
                    this.setState({
                      showValidation: true,
                      validation,
                    });
                  } else {
                    if (type === "add") {
                      const { fileData, ...portfolioData } = portfolioItem;
                      startAddWebsitePortfolio(portfolioData, fileData)
                        .then(() => handleClose());
                    } else {
                      const { id, fileData, ...updates } = portfolioItem;
                      startEditWebsitePortfolio(id, updates, fileData)
                        .then(() => handleClose());
                    }
                  }
                  //   if (type === "add") {
                  //     const { fileData, ...portfolioData } = portfolioItem;
                  //     console.log("fileData:", fileData)
                  //     if (fileData) {
                  //       const file = {
                  //         fileData: fileData,
                  //         category: "portfolio",
                  //         createdDate: (new Date()).getTime(),
                  //         type: fileData.type,
                  //       };
                  //       startAddFile(file)
                  //         .then((fileId) => {
                  //           console.log("fileID:", fileId);
                  //           return startAddWebsitePortfolio({ fileId, ...portfolioData })
                  //         })
                  //         .then(() => handleClose());
                  //     } else {
                  //       startAddWebsitePortfolio(portfolioData)
                  //         .then(() => handleClose());
                  //     }
                  //
                  //   } else {
                  //     const { id, fileData, ...updates } = portfolioItem;
                  //     startEditWebsitePortfolio(id, updates)
                  //       .then(() => handleClose());
                  //   }


                }}
                color="primary">
                {type === "add" ? "Add" : "Done"}
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { portfolioItem } = props;

  return ({
    file: state.filesState.find((file) => file.id === portfolioItem.fileId),
  });
};

const mapDispatchToProps = {
  startAddFile,
  startAddWebsitePortfolio,
  startEditWebsitePortfolio,
  startRemoveWebsitePortfolio,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(PortfolioDialog)



// WEBPACK FOOTER //
// ./src/components/admin/Website/Dialogs/PortfolioDialog.jsx